<template>
	<div
	class="quiz-table flex flex-row items-start justify-start"
	v-if="game">
		<table class="faa-table w-full">
			<!-- Column index label -->
			<tr class="faa-headers">
				<th class="b-n"></th>
				<th class="b-n"></th>
				<th 
				class="faa-header b-n bg-blue text-white text-center py-1"
				:class="{
					'rd-tl': (index == 0),
					'rd-tr': (index == (headers.length - 1)),
					'hidden': (headers.length < 2 && !header.content)
				}"
				v-for="(header, index) in headers" :key="header.column">
					<span>
						{{getColumnIndexLabel(index)}}
					</span>
				</th>
			</tr>

			<!-- Column titles -->
			<tr class="faa-headers">
				<th class="b-n"></th>
				<th class="b-n"></th>
				<th 
				class="faa-header bb-n bg-white text-center p-5"
				:class="{
					'opacity-0 b-n py-0': (headers.length < 2 && !header.content)
				}"
				v-for="header in headers" :key="header.column">
					<p v-if="header.content">
						{{header.content}}
					</p>
				</th>
			</tr>

			<!-- Content lines -->
			<tr class="faa-line"
			v-for="(row, index) in rows" :key="row.line">
				<!-- Line header index label -->
				<td
				class="faa-line-header b-n bg-blue text-white py-6 px-3"
				:class="{ 'rd-tl': (index == 0), 'rd-bl': (index == (rows.length - 1)) }">
					<span>
						{{index + 1}}
					</span>
				</td>

				<!-- Line header title -->
				<td class="faa-line-header br-n bg-white text-center py-6 px-8"
				:class="{ 'bb-n': (index == (rows.length - 1)) }">
					<span v-if="row.content">
						{{row.content}}
					</span>
				</td>

				<!-- Line answers cells -->
				<td
				class="faa-line-content text-center cursor-pointer"
				:class="{
					'bb-n': (index == (rows.length - 1)),
					'true-answer': (showCorrection && correctAnswers[row.line][hIndex]),
					'false-answer': (showCorrection && !correctAnswers[row.line][hIndex]),
					'cursor-not-allowed': showCorrection,
					'active:cursor-not-allowed': showCorrection,
				}"
				v-for="(header, hIndex) in headers"
				:key="header.column"
				@click.prevent="setAnswer(row.line, hIndex)">

					<!-- Switch -->
					<label 
					class="switch cursor-pointer"
					:class="{
						'cursor-not-allowed': showCorrection,
						'active:cursor-not-allowed': showCorrection,
					}">
						<input type="checkbox"
						:checked="answers && answers[row.line] && answers[row.line][hIndex]"
						:disabled="showCorrection">
						<span class="slider round"></span>
					</label>

				</td>
			</tr>
		</table>

		<!-- <p class="quiz-simple-correction rounded-md py-3 px-4 bg-gray-lighter text-left" v-show="showCurrentCorrection"
		:class="{
			'bg-blue-light': isCorrect(),
		}">
			{{game.correction}}
		</p> -->
	</div>

</template>

<script>
	export default {
		name: 'QuizTable',
		props: {
			game: {
				type: Object,
				required: false,
				default: null
			},
			showCorrection: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data(){
			return {
				answers: {},
			}
		},
		computed: {
			headers() {
				if (!this.game)
					return []

				return this.game.headers
				.filter((header) => (header.column != null))
				.sort((h1, h2) => (h1.column - h2.column))
			},
			rows() {
				if (!this.game)
					return []

				return this.game.headers
				.filter((header) => (header.line != null))
				.sort((h1, h2) => (h1.line - h2.line))
			},
			correctAnswers() {
				// Check all question answers
				let correctAnswers = []

				for (var i = 0; i < this.game.questions.length; i++) {
					const question = this.game.questions[i]

					if (question.answers && question.answers.length > 0) {
						const line = question.line
						const column = question.column

						// Create line arrays if needed
						if (!correctAnswers[line]) {
							correctAnswers[line] = {}
						}

						correctAnswers[line][column] = question.answers[0].is_correct
					}
				}

				return correctAnswers
			}
		},
		watch: {
			game: {
				handler() {
					this.answers = {}
				},
				immediate: true,
			},
		},
		methods: {
			getColumnIndexLabel(index) {
				// Convert index to column label like "A", "B", ..., "AA", "AB", ...
				let label = ''

				const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
				for (var i = 0; i < Math.ceil((index + 1) / letters.length); i++) {
					label += letters[index % letters.length]
				}

				return label
			},
			setAnswer(line, column) {
				if (this.showCorrection)
					return

				// Create answer arrays if needed
				if (!this.answers[line]) {
					this.$set(this.answers, line, {})
				}

				this.$set(this.answers[line], column, !this.answers[line][column])
			},
			isCorrect() {				
				// Check if one correct answer is not checked
				for (var i = 0; i < this.game.questions.length; i++) {
					const question = this.game.questions[i]

					if (question.answers && question.answers.length > 0) {
						const line = question.line
						const column = question.column

						if (question.answers[0].is_correct && !this.answers[line][column]) {
							return false
						}
					}
				}

				return true
			},
			getResults() {
				let results = {
					right: 0,
					wrong: 0,
					total: 0,
				}

				// Compare all user answers to correct answers
				for (var i = 0; i < this.game.questions.length; i++) {
					const question = this.game.questions[i]

					if (question.answers && question.answers.length > 0) {
						const line = question.line
						const column = question.column

						results.total += 1

						if (this.correctAnswers[line][column] && this.answers[line] && this.answers[line][column]) {
							results.right += 1
						} else if (!this.correctAnswers[line][column] && (!this.answers[line] || !this.answers[line][column])) {
							results.right += 1
						} else {
							results.wrong += 1
						}
					}
				}

				return results
			},
		},
	}
</script>

<style lang="scss" scoped>

/* The switch - the box around the slider */
.switch {
	position: relative;
	display: inline-block;
	width: 50px;
	height: 24px;
	margin-bottom:0;
}

/* Hide default HTML checkbox */
.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

/* The slider */
.slider {
	@apply border border-gray-lighter bg-gray-lighter;

	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	-webkit-transition: .4s;
	transition: .4s;
}

.slider:before {
	position: absolute;
	content: "";
	height: 16px;
	width: 16px;
	left: 4px;
	bottom: 3px;
	background-color: white;
	-webkit-transition: .4s;
	transition: .4s;
}

input:checked + .slider {
	@apply border-blue bg-blue;
}

input:checked + .slider:before {
	-webkit-transform: translateX(26px);
	-ms-transform: translateX(26px);
	transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
	border-radius: 24px;
}

.slider.round:before {
	border-radius: 50%;
} 

// Right/Wrong answer
.true-answer {
	input + .slider {
		@apply border-green;
	}

	input:checked + .slider {
		@apply bg-green;
	}
}

.false-answer {
	input:checked + .slider {
		@apply bg-red;
	}
}

</style>
